import { Adapter } from '@fmnts/core';
import { IApiNextFormModalButton } from '../api-model';
import { FormModalButton } from '../model/form-modal';

export class ApiModalButtonAdapter implements Adapter<FormModalButton> {
  adapt(item: IApiNextFormModalButton): FormModalButton {
    return {
      action: item.action,
      label: item.label,
      style: item.style ?? '',
    };
  }
}
